import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/FooterStyles.css";
import logo from "../assets/logo.png";
import { getActiveCategories } from "../../utils/storage";
import { Box, IconButton } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GoogleIcon from "@mui/icons-material/Google";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";

// The house brands we lead with in the footer. Kept short deliberately — the
// full list lives in the Trusted Brands marquee on the home page.
const FOOTER_BRANDS = [
  "Camipro",
  "MPCL",
  "Floron",
  "Value",
  "Godrej",
  "Copeland",
  "Voltas",
];

function Footer() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    setCategories(getActiveCategories());
  }, []);

  return (
    <footer className="footer">

      {/* TOP BAR */}
      <div className="footer-topbar">
        <div className="footer-topbar-left">
          <LocationOnIcon className="topbar-icon" />
          <span className="topbar-meta">Tecniqa | HVAC Solutions &nbsp;·&nbsp; Mon-Sat &nbsp;9:00 AM - 6:00 PM IST</span>
        </div>
        <div className="footer-topbar-right">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms">Terms & Conditions</a>
          <a href="/warranty-policy">Warranty</a>
          <a href="/return-policy">Returns</a>
        </div>
      </div>

      {/* MAIN GRID */}
      <div className="footer-main">

        {/* ABOUT */}
        <div className="footer-col footer-col--about">
          <img src={logo} alt="Tecniqa Logo" className="footer-logo" />
          <p className="footer-about">
            Committed to delivering high-quality refrigeration and cooling
            solutions with innovation, reliability, and customer satisfaction
            at the core of everything we do.
          </p>
          <Box className="social-row">
            <a href="https://www.facebook.com/people/Nano-Cloud-Technology/61579555775024/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <IconButton className="social-btn social-btn--facebook">
                <FacebookIcon />
              </IconButton>
            </a>
            <a href="https://www.instagram.com/nanocloudtechnology/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <IconButton className="social-btn social-btn--instagram">
                <InstagramIcon />
              </IconButton>
            </a>
            <a href="https://www.linkedin.com/company/nano-cloud-technology/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <IconButton className="social-btn social-btn--linkedin">
                <LinkedInIcon />
              </IconButton>
            </a>
            <a href="https://nanocloudtechnology.com/" target="_blank" rel="noopener noreferrer" aria-label="Website">
              <IconButton className="social-btn social-btn--google">
                <GoogleIcon />
              </IconButton>
            </a>
          </Box>
        </div>

        {/* OUR BRANDS */}
        <div className="footer-col">
          <h4 className="col-label">Our Brands</h4>
          <ul className="footer-list">
            {FOOTER_BRANDS.map((b) => (
              <li
                key={b}
                role="link"
                tabIndex={0}
                onClick={() => navigate(`/shop-by-brand/${encodeURIComponent(b)}`)}
                onKeyDown={(e) =>
                  e.key === "Enter" &&
                  navigate(`/shop-by-brand/${encodeURIComponent(b)}`)
                }
              >
                {b}
              </li>
            ))}
          </ul>
        </div>

        {/* OUR PRODUCTS */}
        <div className="footer-col">
          <h4 className="col-label">Our Products</h4>
          <ul className="footer-list">
            {categories.map((c) => (
              <li
                key={c.id}
                role="link"
                tabIndex={0}
                onClick={() => navigate(`/category/${c.slug}`)}
                onKeyDown={(e) => e.key === "Enter" && navigate(`/category/${c.slug}`)}
              >
                {c.name}
              </li>
            ))}
          </ul>
        </div>

        {/* CONTACT */}
        <div className="footer-col">
          <h4 className="col-label">Contact Us</h4>

          <a href="tel:+919668246683" className="contact-item">
            <div className="contact-icon">
              <PhoneIcon fontSize="small" />
            </div>
            <div>
              <div className="contact-label">Phone</div>
              <div className="contact-value">+91 8249643544</div>
            </div>
          </a>

          <a href="mailto:support@tecniqa.com" className="contact-item">
            <div className="contact-icon">
              <EmailIcon fontSize="small" />
            </div>
            <div>
              <div className="contact-label">Email</div>
              <div className="contact-value">support@tecniqa.com</div>
            </div>
          </a>

          <div className="contact-item">
            <div className="contact-icon">
              <LocationOnIcon fontSize="small" />
            </div>
            <div>
              <div className="contact-label">Location</div>
              <div className="contact-value">Shop No-2 ,<br />Behind Shakti Continental, <br />Angul , Odisha-759122</div>
            </div>
          </div>
        </div>

        {/* MAP */}
        <div className="footer-col">
          <h4 className="col-label">Find Us</h4>
          <div className="map-box">
            <iframe
              title="Tecniqa Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d900.6369268946939!2d85.1015519120028!3d20.84048626858624!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a18affc0ae810ad%3A0x6be28b1cec18b640!2sR4R2%2B6H7%2C%20004%2C%206th%20Ln%2C%20behind%20hotel%20shakti%20Near%20hanuman%20temple%2C%20Amalapada%2C%20Angul%2C%20Odisha%20759122!5e1!3m2!1sen!2sin!4v1782383150832!5m2!1sen!2sin"
              loading="lazy"
              frameBorder="0"
            />
            <div className="map-label">
              <LocationOnIcon style={{ fontSize: 13 }} />
              DLF Cyber City
            </div>
          </div>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} <strong>Tecniqa</strong>. All rights reserved. A venture by Nano Cloud Technology.</span>
        <div className="footer-badges">
          <span className="badge">ISO Certified</span>
          <span className="badge">HVACR Experts</span>
        </div>
      </div>

    </footer>
  );
}

export default Footer;